import script from "./AppNotificationsContainer.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppNotificationsContainer.vue?vue&type=script&setup=true&lang=ts"

import "./AppNotificationsContainer.vue?vue&type=style&index=0&id=572db472&lang=scss"

const __exports__ = script;

export default __exports__